import { Box } from "@material-ui/core";
import ReplyIcon from '@mui/icons-material/Reply';
import { Button } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';

const SettlementFilePreviewModal = ({
  filePreview,
  onClose,
  open,
  style,
}) => (
  <Modal
    aria-labelledby="transition-modal-title"
    aria-describedby="transition-modal-description"
    open={open}
    onClose={onClose}
    closeAfterTransition
    BackdropComponent={Backdrop}
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        timeout: 500,
      },
    }}
    style={{
      overflow: "auto",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      borderRadius: "10px",
    }}
  >
    <Fade in={open}>
      <Box sx={style} style={{ textAlign: "center", width: "80%", height: "80vh" }}>
        <h3>PDF VIEWER </h3>

        <Box className="form-control" style={{ textAlign: "center", height: "90%" }}>
          {filePreview ? (
            <embed src={filePreview} width="100%" height="93%" type="application/pdf" />
          ) : (
            <div
              style={{
                alignItems: 'center',
                border: '2px dashed rgba(0, 0, 0, .3)',
                fontSize: '2rem',
                height: '100%',
                display: "flex",
                justifyContent: 'center',
                width: '100%',
                marginBottom: "5px",
              }}
            >
              View Area<br />
              Oops! The file is not uploaded yet.
            </div>
          )}

          <Button type="button" onClick={onClose} variant="contained" color="info" style={{ color: "white" }}>
            <ReplyIcon /> Close
          </Button>
        </Box>
      </Box>
    </Fade>
  </Modal>
);

export default SettlementFilePreviewModal;
